export const ACTIVATION_ORDER_SHIPMENT_STATUS_NONE = 'none';
export const ACTIVATION_ORDER_SHIPMENT_STATUS_CONFIRMED = 'confirmed';
export const ACTIVATION_ORDER_SHIPMENT_STATUS_IN_TRANSIT = 'in_transit';
export const ACTIVATION_ORDER_SHIPMENT_STATUS_OUT_FOR_DELIVERY = 'out_for_delivery';
export const ACTIVATION_ORDER_SHIPMENT_STATUS_DELIVERED = 'delivered';
export const ACTIVATION_ORDER_SHIPMENT_STATUS_FAILURE = 'failure';
export const ACTIVATION_ORDER_SHIPMENT_STATUS_LABELS = {
    [ACTIVATION_ORDER_SHIPMENT_STATUS_NONE]: 'Awaiting Shipment',
    [ACTIVATION_ORDER_SHIPMENT_STATUS_CONFIRMED]: 'Confirmed',
    [ACTIVATION_ORDER_SHIPMENT_STATUS_IN_TRANSIT]: 'In Transit',
    [ACTIVATION_ORDER_SHIPMENT_STATUS_OUT_FOR_DELIVERY]: 'Out For Delivery',
    [ACTIVATION_ORDER_SHIPMENT_STATUS_DELIVERED]: 'Delivered',
    [ACTIVATION_ORDER_SHIPMENT_STATUS_FAILURE]: 'Delivery Failed'
};
